/**
 * RFQ request rounds pilot gate.
 *
 * When on, Files → RFQs becomes the "Requests" view (coverage strip, request wizard,
 * rounds) and the old read-only RFQ files list is hidden. Off → today's behaviour.
 * Driven by `settings/rfq_requests`, edited from Settings → Operations → "RFQ requests
 * pilot". Fails closed. Phase 2 (hiding the Hub → Suppliers tab) hangs off this same
 * flag so the Suppliers tab can be sunset without a second rollout.
 */

import { createPilotFlag } from './pilotFlagAccess';

export const RFQ_REQUESTS_DOC_ID = 'rfq_requests';

export const rfqRequestsFlag = createPilotFlag(RFQ_REQUESTS_DOC_ID);

export const subscribeRfqRequestsAccess = rfqRequestsFlag.subscribe;
export const saveRfqRequestsAccess = rfqRequestsFlag.save;
/** Live gate for the signed-in user. */
export const useRfqRequestsAccess = rfqRequestsFlag.useAccess;
